import { Grid2 } from "@mui/material";
import { Fragment } from "react";
import DevicePicker from "./DevicePicker";
import Legend from "./Legend";
import RepositoryPicker from "./RepositoryPicker";

const TopBar = ({ user, useCloud }) => {
  return (
    <Fragment>
      <Grid2 container {...{ size: 12 }} sx={{rowGap:1}}>
        <DevicePicker {...{ user, useCloud }} />
        <RepositoryPicker {...{useCloud}}/>
        <Legend />
      </Grid2>
    </Fragment>
  );
};

export default TopBar;
